export default function (predicts) {
  // predictの配列を表示する文章に変換する
  // とりあえず [とても綺麗か,反射するか,空が見えるか,焼けているか,空が澄んでいるか,どうしようもないなら-1] で運用
  if (predicts[5] === -1){
    // bad
    if(predicts[1] === 1 && predicts[2] === 1){
      return { result: "bad", text: "厳しめ", description: "夕焼けは期待できなさそう、ちょっとだけ色づくかも", per: 20 ,image: 3}
    }
    if (predicts[0] === 1 ) {
      return { result: "bad", text: "普通", description: "あまり期待できないけれど、もしかしたら綺麗な夕焼けになるかも...？", per: 40, image: 2 }
    }
    return { result: "bad", text: "厳しめ", description: "今日は期待できないかも...", per: 10, image: 3 }
  }else if (predicts[0] === -1){ // and predict[5] === 1 
    // 普通
    const sum = predicts.reduce((a,b)=>{return a+b}) * 5
    return { result: "normal", text: "普通", description: "そこそこの夕焼けになるかも", per: 50 + sum, image: 2  }
  }else{
    // 好条件
    if (predicts[1] === 1){
      return { result: "good", text: "好条件", description: "いい条件！綺麗に染まってる夕焼けが見られるかも", per: 80, image: 1 }
    }else{
      return { result: "good", text: "好条件", description: "いい条件！そこそこ綺麗な夕焼けが見られるかも", per: 70, image: 1 }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/predictMapper.js